import setReduxAction from 'modules/redux/actions/set'
import {
  TRAINING_USER_LOCAL_STORAGE_KEY,
  TRAINING_USERS_PATH
} from 'modules/training/modules/training-users/constants'
import setItemLocalStorageUtil from 'modules/local-storage/set-item/index.js'
import updateTrainingUserAction from 'modules/training/modules/training-users/actions/update/index.js'
import { USER_KEY } from '@gymaholic/packages'
import saveTrainingUserAction from 'modules/training/modules/training-users/actions/save/index.js'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current/index.js'

export function updateNewCustomerDiscountExpiresAtUserAction (value) {
  return (dispatch, getState) => {
    dispatch(
      setReduxAction({
        type: 'USER_SET_NEW_CUSTOMER_DISCOUNT_EXPIRES_AT',
        payload: {
          path: TRAINING_USERS_PATH.NEW_CUSTOMER_DISCOUNT_EXPIRES_AT,
          value
        }
      })
    )

    setItemLocalStorageUtil(TRAINING_USER_LOCAL_STORAGE_KEY.NEW_CUSTOMER_DISCOUNT_EXPIRES_AT, value)

    const trainingUser = getCurrentTrainingUserSelect(getState())
    if (!trainingUser) {
      return
    }

    dispatch(
      updateTrainingUserAction({
        key: USER_KEY.NEW_CUSTOMER_DISCOUNT_EXPIRES_AT,
        value
      })
    )

    dispatch(saveTrainingUserAction())
  }
}
